import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PaymentMethods from "../components/Dashboard/PaymentMethods";
import { UserContext } from "../context/UserContext";

const PaymentMethodsPage = () => {
  const { userData } = useContext(UserContext);
  const navigate = useNavigate();

  const PAYER_ROLES = ["LANDLORD", "PROPERTY_MANAGER", "HOMEOWNER", "STR_HOST"];

  useEffect(() => {
    if (userData && !PAYER_ROLES.includes(userData.accountType)) {
      navigate("/dashboard");
    }
  }, [userData, navigate]);

  if (userData && !PAYER_ROLES.includes(userData.accountType)) {
    return null;
  }

  return (
    <div className="max-w-[1440px] m-auto pt-24 md:px-6 px-4 pb-20 min-h-[60vh]">
      <PaymentMethods />
    </div>
  );
};

export default PaymentMethodsPage;
